import React, {Fragment, useState, useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import { Select } from '../../';
import {connect} from 'react-redux';







function FolderSelector(props) {
    const [folder_id, setFolderId] = useState(props.default);
    let return_resources = [];


    useEffect(() => {
        if (props.folders == undefined || props.folders[props.folder_type] == undefined) {
            props.indexFolders();
        }
    }, []);

    useEffect(()=>{
        console.log('DEFAULT UPDATED', props.default);
        setFolderId(props.default);
    },[props.default]);


    
    function folderLevelSelectData(folders_select_data, folder_id = null, level = 0) {
        if(props.folders!=undefined && props.folders[props.folder_type]!=undefined){
        for (let key in props.folders[props.folder_type]) {
            let f = JSON.parse(JSON.stringify(props.folders[props.folder_type][key]));
            if (f.folder_id == folder_id) {
                let items_count=0; for(let r of props.resources){if(r.folder_id==f.id){items_count+=1;}}
                f.level = level;
                f.name = f.name + ' (' + items_count + " " + props.folder_type.toLowerCase() +')';
                folders_select_data.push(f);
                folders_select_data = folderLevelSelectData(folders_select_data, f.id, level + 1);
            }
        }}
        return folders_select_data;
    }
    let main_item_count=0;
    for (let r of props.resources) {
        if(r.folder_id==undefined || r.folder_id==null){main_item_count+=1;}
        if (r.folder_id == folder_id || folder_id == 'all_folders' || props.folders == undefined || props.folders[props.folder_type] == undefined || props.folders[props.folder_type].length==0) {
            return_resources.push(r);
        }
    }

    console.log(props, props.resources, folder_id, 'FOLDER FOLDER ID ID', return_resources);

    let folders_select_data = folderLevelSelectData([{ id: 'all_folders', name: "All Folders (" + props.resources.length + " " + props.folder_type.toLowerCase() + ")" }, {id: 'main_folder', name: 'Main folder (' + main_item_count + " " + props.folder_type.toLowerCase() +')' }]);



    return (
        <Fragment>
            {(folders_select_data.length<3)?null:<Grid item xs={12} sm={6} md={4}>
                <Select title={(props.title==undefined)?"Folder":props.title} required name={props.folder_type.toLowerCase() + '_folder_id'} select_data={folders_select_data} onChange={(e) =>{if(e.target.value=='main_folder'){setFolderId(undefined);}else{setFolderId((e.target.value=='all_folders')?'all_folders':Number(e.target.value));}}} style={{ maginBottom: '5px', marginTop: '0px' }} />
            </Grid>}
            {props.displayResourceSelector(return_resources)}
        </Fragment>
    )
}


export default connect(ss, dd)(FolderSelector);


function dd(dispatch){
    return{
        indexFolders: () => { dispatch({ type: "REQUEST_FOLDER_INDEX" }); }
    }
}

function ss(state){
    return {
        refresh: state.folders.refresh,
        folders:state.folders.data
    }
}